import cn from 'classnames';

import ccs1 from '../../icons/ev-plugs/ccs1.png';
import ccs2 from '../../icons/ev-plugs/ccs2.png';
import chademo from '../../icons/ev-plugs/chademo.png';
import euro from '../../icons/ev-plugs/euro.svg';
import gbtAc from '../../icons/ev-plugs/gbt-ac.svg';
import gbtDc from '../../icons/ev-plugs/gbt-dc.png';
import nacs from '../../icons/ev-plugs/nacs.png';
import type1 from '../../icons/ev-plugs/type1.svg';
import type2 from '../../icons/ev-plugs/type2.svg';

/*
 * Connector icons:
 *   Type 1 / Type 2 — @mdi/svg (same sources as EVBOOST filters)
 *   GB/T AC — flat-top 7-pin silhouette (GB/T AC face, cf. common EVCI diagrams)
 *   DC set — https://evua.site/static/resources/ (station/4164)
 */
const PLUG_IMAGES = {
  TYPE_1: { src: type1, aspect: 1 },
  TYPE_2: { src: type2, aspect: 1 },
  TYPE_2_NO_CABBLE: { src: type2, aspect: 1 },
  GBT: { src: gbtAc, aspect: 100 / 108 },
  EURO_SOCKET: { src: euro, aspect: 1 },
  CCS1: { src: ccs1, aspect: 37 / 55 },
  CCS2: { src: ccs2, aspect: 37 / 55 },
  CCS_2: { src: ccs2, aspect: 37 / 55 },
  GBT_DC: { src: gbtDc, aspect: 49 / 47 },
  CHADEMO: { src: chademo, aspect: 1 },
  NACS: { src: nacs, aspect: 49 / 42 },
};

export const PlugTypeIcon = ({ plugType, size = '1.35em', className, title, ...props }) => {
  const image = PLUG_IMAGES[plugType];

  if (!image) {
    return null;
  }

  return (
    <span
      className={cn('plug-type-icon', className)}
      style={{
        width: `calc(${size} * ${image.aspect})`,
        height: size,
        display: 'inline-block',
        flexShrink: 0,
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${image.src})`,
        maskImage: `url(${image.src})`,
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      {...props}
    />
  );
};
